




import { Component, Vue } from "vue-property-decorator";

import { namespace } from "vuex-class";
import { LicenseModel } from "../models";
import Stats from "../components/Stats.vue";

const clStore = namespace("compendalicense");
const snackStore = namespace("snackbar");

@Component({
  components: { Stats }
})
export default class LicenseInfo extends Vue {
  @clStore.Getter currentLicense!: LicenseModel;

  @clStore.Action fetchCurrentLicense!: () => Promise<void>;

  @snackStore.Mutation defaultError!: () => void;

  mounted() {
    this.fetchCurrentLicense().catch(() => {
      this.defaultError();
    });
  }
}
